// Release notes shown in the "Wat is er nieuw" card on the profile page.
// Source of truth is CHANGELOG.md in the repository root — keep the top entry
// in sync with its most recent release (highlights only).
const changelog = [
  {
    version: 'Versie 2.2',
    items: [
      'Gebruikersaccounts worden nu los van medewerkersgegevens beheerd.',
      'Met het nieuwe beheer van API-sleutels koppel je externe systemen veilig.',
      'Rollen en rechten zijn vereenvoudigd tot beheerder, manager en recruiter.',
      'De publieke API en de bijbehorende documentatie zijn uitgebreid en verbeterd.',
    ],
  },
];

export default changelog;
